import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
    // load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'en',
        debug: false,
        load: 'languageOnly',
        ns: [
            'common', // common resource use everywhere in the application will be defined under that namespace
            'menu',
            'myProfile', // sample namespace - resource dedicated to sample will be defined under that namespace
            'validation',
            'resources',
            'ErrorReporting',
            'httpError',
            'sample',
            'calendar',
            'intermediaries',
            'application',
            'pos'
        ],
        defaultNS: 'resources',
        keySeparator: '$',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
